import React from 'react'

import { Textarea } from '../components'

interface MultilineStringInputProps {
  label: string
  value: string
  required: boolean
  onChange: (value: string) => void
}

export function MultilineStringInput({ label, value, required, onChange }: MultilineStringInputProps) {
  return (
    <Textarea
      label={label}
      required={required}
      placeholder="Insert text here"
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e.target.value)}
      value={value}
      autoFocus
      data-testid="chart-modal-multiline-string-textarea"
    />
  )
}
